import { baseApi } from './baseApi';
import type { SoulmatesResponse } from '../types';

const soulmatesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSoulmates: builder.query<SoulmatesResponse, { limit?: number } | void>({
      query: (args) => {
        const params = new URLSearchParams();
        if (args?.limit) params.append('limit', args.limit.toString());
        const queryString = params.toString();
        return `/users/soulmates${queryString ? `?${queryString}` : ''}`;
      },
      providesTags: ['Soulmates'],
      keepUnusedDataFor: 5 * 60,
    }),
  }),
});

export const {
  useGetSoulmatesQuery,
} = soulmatesApi;
